import { Component, ChangeDetectionStrategy, Input } from "@angular/core";

@Component({
  selector: "static-header",
  templateUrl: "./static-header.component.html",
  styleUrls: ["./static-header.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StaticHeaderComponent {
  @Input() logo = "rbc_shield-text_ondark_en";
  enToggle = true;
}
